/*
 * @Author: 
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: 
 * @LastEditTime: 2022-06-29 12:26:29
 * @FilePath: /Cup2Market/src/views/ActivityPlace/webApi.js
 * @Description: 
 */
import request from "@/utils/request";

export function getActTheme(id) {
  return request({
    url: "/product/participate/act-goods/" + id,
    method: "get",
  });
}
export function getActivityDetail(id) {
  return request({
    url: "/product/activity/h5/" + id,
    method: "get",
  });
}
export function getSuitGoods(id) {
  return request({
    url: "/product/activity-theme/suit-list/" + id,
    method: "get",
  });
}
